var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9731 0.614424C15.6054 0.236085 16.3946 0.236084 17.0269 0.614424L20.0823 2.44256C21.4614 3.26774 22.9046 3.98077 24.398 4.57475L27.7488 5.90755C28.4177 6.1736 28.892 6.77859 28.9907 7.49164L29.5075 11.2236C29.7336 12.8566 30.0939 14.4681 30.5847 16.0419L31.6593 19.4869C31.8704 20.1637 31.7074 20.9017 31.2309 21.4266L28.7733 24.1343C27.7811 25.2275 26.8708 26.3925 26.0501 27.6197L23.7657 31.0355C23.3668 31.6319 22.679 31.969 21.9632 31.9187L16 31.5L10.0368 31.9187C9.32104 31.969 8.63317 31.6319 8.23427 31.0355L5.94992 27.6197C5.12917 26.3925 4.21894 25.2275 3.22666 24.1343L0.751109 21.4069C0.284335 20.8926 0.117764 20.173 0.311091 19.5059L2.15282 13.1512L2.99925 7.47608C3.10434 6.7715 3.57626 6.176 4.2382 5.91272L7.60204 4.57475C9.0954 3.98076 10.5386 3.26774 11.9177 2.44256L14.9731 0.614424Z",
    fill: "#CCB72B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.9731 0.614424C15.6054 0.236085 16.3946 0.236084 17.0269 0.614424L20.0823 2.44256C21.4614 3.26774 22.9046 3.98077 24.398 4.57475L27.7488 5.90755C28.4177 6.1736 28.892 6.77859 28.9907 7.49164L29.5075 11.2236C29.7336 12.8566 30.0939 14.4681 30.5847 16.0419L31.6593 19.4869C31.8704 20.1637 31.7074 20.9017 31.2309 21.4266L28.7733 24.1343C27.7811 25.2275 26.8708 26.3925 26.0501 27.6197L23.7657 31.0355C23.3668 31.6319 22.679 31.969 21.9632 31.9187L16 31.5L10.0368 31.9187C9.32104 31.969 8.63317 31.6319 8.23427 31.0355L5.94992 27.6197C5.12917 26.3925 4.21894 25.2275 3.22666 24.1343L0.751109 21.4069C0.284335 20.8926 0.117764 20.173 0.311091 19.5059L2.15282 13.1512L2.99925 7.47608C3.10434 6.7715 3.57626 6.176 4.2382 5.91272L7.60204 4.57475C9.0954 3.98076 10.5386 3.26774 11.9177 2.44256L14.9731 0.614424Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.18,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.5,
    y1: 32,
    x2: 5,
    y2: -3.25963e-8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.3e2e8b7fa2699609b5ab45c8ccdd3ea0.svg";
export { ForwardRef as ReactComponent };